module.exports = __webpack_public_path__ + "static/img/qrcode_h5.becd768.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/chataxera/qrcode_h5.png
// module id = 6gdP
// module chunks = 34